import { useEffect, useState } from "react";

export function useApi(uri) {
  const [loading, setLoading] = useState(true);
  const [results, setResults] = useState([]);

  useEffect(() => {
    fetch(`https://manage.fibank.al${uri}`)
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        setResults(data);
      });
  }, [uri]);

  return { loading, data: results };
}

export async function postApi(uri, body) {
  const rawResponse = await fetch(
    `https://manage.fibank.al/applications/${uri}`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  );
  const content = await rawResponse.json();

  return content;
}
